import React, { FC, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingButton from "../../components/LoadingButton/index";
import Button from "@material-ui/core/Button";

import { useParams, useLocation, useHistory } from "react-router-dom";
// import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { toMomentString } from "config/util";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Modal,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Alert,
  Row,
  Spinner,
} from "reactstrap";
import TextFieldNumber from "../../components/TextField/TextFieldNumber";

import { initReactI18next, useTranslation } from "react-i18next";

import validator from "validator";

import moment from "moment/moment";
import ReactBSAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import IntlTelInput from "react-intl-tel-input";

import ReactDatetime from "react-datetime";

import { t } from "../../services/i18n/index";
import { toNumber } from "config/util";

const AccountsAuthModal = ({
  loading,
  modal,
  close_modal,
  dispatch_info,
  dispatch_danger,
  active_wallet_id,
  active_symbol,
  dispatch_post_wallets_id_withdraw,
  active_wallets_deposit_balance,
}) => {
  const [t, i18n] = useTranslation();
  const maps = useSelector((state) => state.reduce_get_maps);
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const [amount, set_amount] = useState("");

  const reduce_get_accounts = useSelector((state) => state.reduce_get_accounts);
  const history = useHistory();

  let minimumMessage = "";

  if (active_symbol == "BTC") {
    minimumMessage = `(${t("最低")} 0.0002 BTC)`;
  }

  if (active_symbol == "ETH") {
    minimumMessage = `(${t("最低")} 0.0025 ETH)`;
  }

  return (
    <>
      <Modal
        className="modal-dialog-centered"
        size="md"
        isOpen={modal}
        toggle={() => {
          close_modal();
          set_amount("");
        }}
      >
        <div className="modal-header justify-content-center pb-0">
          <h4 className="title title-up mt-0">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => {
                close_modal();
                set_amount("");
              }}
            >
              <i className="nc-icon nc-simple-remove" />
            </button>

            {t("自分用に送付")}
          </h4>
        </div>
        <div className="modal-body">
          <Container>
            <Row>
              <Col md="12">
                <div className="d-flex justify-content-between jumbotron p-3">
                  <span className="text-muted">
                    {active_symbol}
                    {t("残高")}
                  </span>
                  <span>
                    {toNumber(
                      active_wallets_deposit_balance,
                      maps.coin_decimals[active_symbol].price
                    )}{" "}
                    {active_symbol}
                  </span>
                </div>
                <span style={{ color: "red" }}>
                  {reduce_get_accounts.verify_flg
                    ? t("")
                    : t("住所や本人確認書類の登録を行ってください。")}
                </span>
                <div className="form-group bmd-form-group">
                  <TextFieldNumber
                    fullWidth={true}
                    value={amount}
                    set_value={set_amount}
                    label={t("出金金額")}
                    endAdornment={active_symbol}
                    decimalScale={maps.coin_decimals[active_symbol].price}
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="modal-footer justify-content-center">
          <Container>
            <Row className="buttons-row">
              <Col md="6" sm="6">
                <FormGroup>
                  <LoadingButton
                    onClick={(e) => {
                      e.preventDefault();

                      if (reduce_get_accounts.verify_flg) {
                        dispatch_post_wallets_id_withdraw(
                          {
                            id: active_wallet_id,
                            amount,
                          },
                          () => {
                            dispatch_info("出金を申請しました。");
                            close_modal();
                            set_amount("");
                          }
                        );
                      } else {
                        // dispatch_danger(
                        //   "住所や本人確認書類画像の登録をお願いします。"
                        // );
                        history.push("/settings");
                      }
                    }}
                    pending={loading}
                    // variant="outlined"
                    variant="contained"
                    style={{
                      width: "100%",
                      backgroundColor: primary,
                      color: "white",
                    }}
                  >
                    {reduce_get_accounts.verify_flg ? (
                      <>
                        {t("出金申請")}
                        <br />
                        {minimumMessage}
                      </>
                    ) : (
                      t("本人確認書類の登録")
                    )}
                  </LoadingButton>
                </FormGroup>
              </Col>
              <Col md="6" sm="6">
                <FormGroup>
                  <LoadingButton
                    onClick={() => {
                      close_modal();
                      set_amount("");
                    }}
                    pending={loading}
                    // variant="outlined"
                    variant="contained"
                    style={{
                      width: "100%",
                      // backgroundColor: primary,
                      // color: "white",
                    }}
                  >
                    {t("キャンセル")}
                  </LoadingButton>
                </FormGroup>
              </Col>
            </Row>
          </Container>
        </div>
      </Modal>
    </>
  );
};

export default AccountsAuthModal;
